var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lang", style: { width: _vm.width } },
    [
      _c(
        "a-select",
        {
          attrs: { placeholder: _vm.placeholder, size: _vm.size },
          on: {
            change: function($event) {
              return _vm.onChange(_vm.langCode)
            }
          },
          model: {
            value: _vm.langCode,
            callback: function($$v) {
              _vm.langCode = $$v
            },
            expression: "langCode"
          }
        },
        _vm._l(_vm.options, function(item, index) {
          return _c(
            "a-select-option",
            {
              key: index,
              attrs: { value: item.value, title: _vm.language[item.langKey] }
            },
            [_vm._v(_vm._s(_vm.language[item.langKey]))]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }